import { once } from 'ramda';
import { UserSyncArguments } from 'user-sync/index.types';

const ID = '64';
const IABids = [80];
const SUPPLY_ID = 'dSvJjhJF';

export const createPixel = (gdprApplies?: boolean, tcString?: string | null): HTMLIFrameElement => {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src =
    gdprApplies && tcString
      ? `https://match.sharethrough.com/universal/v1?supply_id=${SUPPLY_ID}&gdpr=${gdprApplies}&gdpr_consent=${tcString}`
      : `https://match.sharethrough.com/universal/v1?supply_id=${SUPPLY_ID}`;

  return iframe;
};

export default once(({ userSyncPixelsManager, fastdom, context }: UserSyncArguments): void =>
  userSyncPixelsManager.create(context.gdprConsent, ID, IABids, () => {
    const iframe =
      context.gdprConsent.consent?.gdprApplies && context.gdprConsent.consent?.tcString
        ? createPixel(context.gdprConsent.consent.gdprApplies, context.gdprConsent.consent.tcString)
        : createPixel();

    fastdom.mutate(function userSyncSharethoughAddElement() {
      document.body.appendChild(iframe);
    });
  }),
);
